const parse = () => {
    const cookies = {};
    if (document.cookie?.length) {
        const cookieEntries = document.cookie.split(';');
        for (let i = 0, item, len = cookieEntries.length; i < len; i++) {
            item = cookieEntries[i].replace(/^(\s|\u00A0)+/g, '').split('=');
            cookies[item[0]] = decodeURIComponent(item[1]);
        }
    }
    return cookies;
};
export const getAll = () => {
    let items;
    try {
        items = parse();
    }
    catch { }
    return items ?? {};
};
export const getItem = (key, options = {}) => {
    const { raw } = options;
    let item;
    try {
        const value = parse()[key];
        item = raw ? value : JSON.parse(value ?? '');
    }
    catch { }
    return item ?? null;
};
export const setItem = (key, value, options = {}) => {
    const { raw, expires, path, domain, samesite, secure } = options;
    try {
        let date;
        if (typeof expires === 'number') {
            date = new Date();
            date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
        }
        else {
            date = expires;
        }
        let cookie = `${key}=${encodeURIComponent(raw ? String(value) : JSON.stringify(value))}`;
        cookie += date ? `; expires=${date.toUTCString()}` : '';
        cookie += path ? `; path=${path}` : '';
        cookie += domain ? `; domain=${domain}` : '';
        cookie += samesite ? `; samesite=${samesite}` : '';
        cookie += secure ? '; secure' : '';
        document.cookie = cookie;
    }
    catch { }
};
export const removeItem = (key, options = {}) => {
    try {
        setItem(key, '', { ...options, raw: true, expires: -1 });
    }
    catch { }
};
